// extracted by mini-css-extract-plugin
export var base = "_1d-0";
export var updateBanner = "_1d-1";